import { useEffect } from 'react';
var useEffectOnce = function (effect) {
    useEffect(effect, []);
};
export var useMount = function (fn) {
    useEffectOnce(function () {
        fn();
    });
};
//# sourceMappingURL=index.js.map